import React from 'react';
import { useEffect, useState } from "react";

function Iframe(props) {
    return (<div dangerouslySetInnerHTML={ {__html:  props.iframe?props.iframe:""}} />);
  }

  const Banyaob = () => {
  const [item, setItem] = useState([]);
  useEffect(()=>{
    fetch('http://kosdom.ru/banyaob.php')
    .then(res => res.json())
    .then(
      (result)=>{
          setItem(result);
        console.log(result);
      }
    )
  },[]);

  return (
    <div className="container">
      <div className="m-5">
        <div className="row p-0 overflow-hidden h-100">
          <div className="row">        
          
           {item.map(item => <div key={item.id} className="row  mt-4">
           <div className="row"  style={{display: 'flex', justifyContent: 'center', fontSize: "20px", margin:"20px"}}>
              {item.text }</div><br /><br />
              <div className="row" ><div className="col-lg-3" ></div> 
              </div> <br />
              
              <div className="row" ><div className="col-md-3"></div>
              <div className="col-md-6"><Iframe iframe={item.video} /></div>
              </div> 

              <div className="row" ><div className="col-md-3"></div>
              <div className="col-md-7"><img src={item.image} className="img-fluid"/></div></div>
            </div>  
           )}
          </div>
        </div>
      </div>
    </div>
  )}


export default Banyaob;